import { jsx as _jsx } from "react/jsx-runtime";
import { Quote } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
export const TrustPilotQuote = (blok)=>{
    const { quote , author , rating  } = blok;
    return /*#__PURE__*/ _jsx("div", {
        ...storyblokEditable(blok),
        children: /*#__PURE__*/ _jsx(Quote, {
            text: quote,
            author: author,
            rating: Number.parseInt(rating, 10)
        })
    });
};
export default TrustPilotQuote;
